/**
 * Client-side CSV generation and download utility.
 * Includes BOM for Excel Korean compatibility.
 */

/**
 * \uBD80\uD638\u00B7\uAD6C\uBD84\uC790\uB9CC\uC73C\uB85C \uC774\uB904\uC9C4 \uC815\uC0C1 \uD45C\uAE30\uAC12(placeholder `-`, \uC74C\uC218 \uC2DC\uAC04 `-1:30`, `-1,200`).
 * \uC218\uC2DD \uAC00\uB4DC\uC5D0\uC11C \uC81C\uC678\uD574 \uADFC\uD0DC CSV \uC758 `-` \uCEEC\uB7FC\uC774 `'-` \uB85C \uBCF4\uC774\uC9C0 \uC54A\uAC8C \uD55C\uB2E4.
 */
const PLAIN_NUMERIC = /^-(\d[\d:.,]*)?$/;

/**
 * CSV \uC140 \uC9C1\uB82C\uD654.
 * 1) CSV-injection \uAC00\uB4DC \u2014 \uC218\uC2DD\uC73C\uB85C \uD574\uC11D\uB418\uB294 \uC120\uB450 \uBB38\uC790\uB97C `'` \uB85C \uBB34\uB825\uD654.
 *    `-` \uB294 \uC815\uC0C1 \uD45C\uAE30\uAC12(PLAIN_NUMERIC)\uC774 \uC544\uB2D0 \uB54C\uB9CC \uB9C9\uB294\uB2E4(DDE \uD398\uC774\uB85C\uB4DC\uB294 \uB4A4\uC5D0 \uC218\uC2DD\uC774 \uBD99\uC5B4 \uAC78\uB9B0\uB2E4).
 * 2) RFC4180 \u2014 comma/quote/CR/LF \uD3EC\uD568 \uC2DC \uB530\uC634\uD45C escape(\uAC00\uB4DC \uC801\uC6A9 *\uD6C4* \uBB38\uC790\uC5F4 \uAE30\uC900).
 */
function escapeCsvCell(value: string): string {
  const cell =
    /^[=+@]/.test(value) || (value.startsWith('-') && !PLAIN_NUMERIC.test(value))
      ? `'${value}`
      : value;
  return /[",\n\r]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell;
}

export function buildCsvString(headers: string[], rows: string[][]): string {
  const headerLine = headers.map(escapeCsvCell).join(',');
  const dataLines = rows.map((row) => row.map(escapeCsvCell).join(','));
  // \uD589 \uAD6C\uBD84\uC790\uB294 CRLF \u2014 RFC4180 \uC774\uC790 \uC708\uB3C4\uC6B0 \uC5D1\uC140 \uAE30\uBCF8. BOM \uC740 \uC5D1\uC140 UTF-8 \uC778\uC2DD\uC6A9.
  return '\uFEFF' + [headerLine, ...dataLines].join('\r\n');
}

export function downloadCsv(filename: string, headers: string[], rows: string[][]): void {
  const csv = buildCsvString(headers, rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
